var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M25,0,17.275,15.661,0,18.168,12.5,30.357,9.55,47.568,25,39.443l15.45,8.125L37.5,30.357,50,18.171l-17.275-2.5Z","fill":"#dbe1ea"}));
}

Star.defaultProps = {"width":"50","height":"47.568","viewBox":"0 0 50 47.568"};

module.exports = Star;

Star.default = Star;
